<template>
  <v-row>
    <v-col cols="12" md="4" v-for="faculty in statuses_faculties_places" :key="faculty.department_id">
      <v-hover>
        <template v-slot:default="{ hover }">
          <v-card
            rounded="xl"
            min-height="220px"
          >
            <v-card-title>
              <v-list-item two-line>
                <v-list-item-content class="text-center">
                  <v-list-item-title class="text-h5">
                    {{ faculty.department_abbreviation }}
                  </v-list-item-title>
                  <v-list-item-subtitle>{{ faculty.department_name }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card-title>
            <v-card-text v-if="faculty.count_rooms !== 0">
              <v-row align="center" dense>
                <v-col cols="12" md="4" v-for="(status_faculty, index) in faculty_base_data" :key="index">
                  <v-card outlined class="text-center" max-height="100px" rounded="xl">
                    <p class="mt-2 mb-0 text-subtitle-1 mx-auto">{{ status_faculty }}</p>
                    <v-card-text class="text-h6">
                      <p v-if="index === 0">{{ faculty.count_places.count_places_occupied }}</p>
                      <p v-if="index === 1">{{ faculty.count_places.count_places_total }}</p>
                      <p v-if="index === 2">{{ faculty.count_rooms }}</p>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text v-else class="d-flex justify-center">
              <v-alert
                width="300px"
                text
                type="info"
                color="teal"
              >Места не распределены
              </v-alert>
            </v-card-text>

            <v-fade-transition>
              <v-overlay
                v-if="hover"
                absolute
                color="#036358"
              >
                <v-btn
                  @click="openDialog(faculty.department_id)"
                  rounded
                  class="ma-2"
                  color="teal"
                >
                  Открыть подробней
                </v-btn>
              </v-overlay>
            </v-fade-transition>
          </v-card>
        </template>
      </v-hover>
    </v-col>
  </v-row>
</template>

<script>
    import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
    import _ from "lodash";

    export default {
        name: "CardsFacultyPlaces",
        props: {
            dialog_vis: {
                type: Boolean
            }
        },
        data: () => ({
            faculty_base_data: ['Занято мест', 'Всего мест', 'Всего комнат']
        }),
        computed: {
            ...mapState({
                statuses_faculties_places: state => state.placesInDormitories.statuses_faculties_places,
            }),
            ...mapGetters({
            }),
        },
        methods: {
            ...mapActions({
                GetFacultyPlaces: 'placesInDormitories/GetFacultyPlaces',
            }),
            ...mapMutations({
            }),
            openDialog(department_id) {
                this.$emit('updateProp', {
                    dialog_vis: !this.dialog_vis,
                    department_id: department_id
                })
                this.GetFacultyPlaces(department_id);
            },
        },
    }
</script>

<style scoped>

</style>